import HomeLayout from "../layouts/homeLayout";
import noneLayout from "../layouts/NoneLayout";
import Page404 from "../pages/404";
import CreateAchie from "../pages/CreateAchie";
import CreateAdminPost from "../pages/CreateAdminPost";
import CreateUser from "../pages/CreateUser";
import DateConfig from "../pages/DateConfig";
import DetailAdminPost from "../pages/DetailAdminPost";
import DetailPostCodes from "../pages/DetailPostCodes";
import Login from "../pages/login";
import ManageAdminPost from "../pages/ManageAdminPost";
import ManagePost from "../pages/ManagePost";
import ManageUser from "../pages/ManageUser";
import ManageWeekConfig from "../pages/ManageWeekConfig";
import PostCodeManage from "../pages/PostCodeManage";
import Ranking from "../pages/Ranking";
import UserActivities from "../pages/UserActivities";
const getRoutes = (isLoggedIn) => {
  const AppRoutes = [];

  if (isLoggedIn) {
    AppRoutes.push({
      path: "/ranking",
      component: Ranking,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/userActivities/:userId/:lastName/:firstName",
      component: UserActivities,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/user-management",
      component: ManageUser,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/post-approval",
      component: ManagePost,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/post-code-manage",
      component: PostCodeManage,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/post-code-detail/:id",
      component: DetailPostCodes,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/create-user",
      component: CreateUser,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/week-config",
      component: ManageWeekConfig,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/date-config",
      component: DateConfig,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/admin-post",
      component: ManageAdminPost,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/create-post",
      component: CreateAdminPost,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/edit-post/:id",
      component: DetailAdminPost,
      layout: HomeLayout,
    });
    AppRoutes.push({
      path: "/create-achie",
      component: CreateAchie,
      layout: HomeLayout,
    });
  } else {
    // Show login page for both root and assignment paths when not logged in
    AppRoutes.push({ path: "/", component: Login, layout: noneLayout });
  }
  // 404 route should be last
  AppRoutes.push({ path: "/", component: Login, layout: noneLayout });
  AppRoutes.push({ path: "/*", component: Page404, layout: noneLayout });

  return AppRoutes;
};

export default getRoutes;
